/* eslint-disable react-hooks/exhaustive-deps */
// @vendors
import { useMemo } from 'react'
import { TableCell, TableRow, Box } from '@mui/material'

// @assets
import { EditPayrollStyle } from '../../../assets/css/payroll-style'

// @helpers
import {
    convertNameStateStatus,
    formattDate,
    getTargetGroup,
    getTargetGroupTooltip,
    HtmlTooltip,
} from '../../../helpers/FunctionsUtils'
import { theme } from '../../../assets/theme'

const FormEditDetail = ({data}) => {
    const style = useMemo(() => EditPayrollStyle(), []);

    const  certifiedTargetGroup = () => {
        return(
            <Box sx={{display:'flex', flexDirection:'column'}}>
                {customText('Code: ', data?.certifiedTargetGroup?.code)}
                {customText('Flag: ', data?.certifiedTargetGroup?.flag)}
                {customText('Target Group: ', data?.certifiedTargetGroup?.targetGroup)}
             </Box>
        )
    }   
    
    const  customText = (initialText, text) => {
        return(
            <Box sx={{display:'flex', gap:'10px', alignItems:'center'}}>
                <span style={{ color: theme.palette.secondary.black, fontWeight: '700' }}>{initialText}</span>
                <p style={{ color: theme.palette.secondary.black }}>{text}</p>
            </Box>
        )
    }   

  return (
    <TableRow sx={{display:'flex'}}>
        <TableCell sx={style.tableCellRow}>{formattDate(data?.lastSyncDate)}</TableCell>
        <TableCell sx={style.tableCellRow}>{convertNameStateStatus(data?.stateStatus)}</TableCell>
        <TableCell sx={style.tableCellRow}>{data?.employeeFullName}</TableCell>
        <TableCell sx={style.tableCellRow}>{data?.employeer}</TableCell>
        <TableCell sx={style.tableCellRow}>{data?.employeerRate}</TableCell>
        <TableCell sx={style.tableCellRow}>
            <HtmlTooltip title={certifiedTargetGroup() ?? ''} placement="right-start">
            {data?.certifiedTargetGroup?.targetGroup}
          </HtmlTooltip>
        </TableCell>
        <TableCell sx={style.tableCellRow} >
            <HtmlTooltip title={getTargetGroupTooltip(data?.targetGroups) ?? ''} placement="right-start">
                {getTargetGroup(data?.targetGroups, false)}
          </HtmlTooltip>
        </TableCell>

        <TableCell sx={style.tableCellRow}>
            {getTargetGroup(data?.targetGroups, true)}
        </TableCell>

        <TableCell sx={style.tableCellRow}>{formattDate(data?.startDate)}</TableCell>

        <TableCell sx={style.tableCellRow}>
            {data?.currentYTDGrossWages}
        </TableCell>

        <TableCell sx={style.tableCellRow} >{data?.currentYTDHours}</TableCell>
        <TableCell sx={style.tableCellRow} >{data?.wotcCreditMultiplier}</TableCell>
        <TableCell sx={style.tableCellRow} >{data?.maxWage}</TableCell>
        <TableCell sx={style.tableCellRow} >{data?.maxTaxCredit}</TableCell>
    </TableRow>
  )
}

export default FormEditDetail